import { ServerOperatingSystems } from "@carbon/pictograms-react";
import { CarbonForIbmDotcom } from "@carbon/pictograms-react";
import { AccessManagement } from '@carbon/pictograms-react';
import * as React from 'react';
export default {
  ServerOperatingSystems,
  CarbonForIbmDotcom,
  AccessManagement,
  React
};